/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentInferencerPolymorphic } from './ConversationalAgentInferencerPolymorphic';
import {
  ConversationalAgentInferencerPolymorphicFromJSON,
  ConversationalAgentInferencerPolymorphicFromJSONTyped,
  ConversationalAgentInferencerPolymorphicToJSON,
} from './ConversationalAgentInferencerPolymorphic';

/**
 *
 * @export
 * @interface PaginatedConversationalAgentInferencerPolymorphicList
 */
export interface PaginatedConversationalAgentInferencerPolymorphicList {
  /**
   *
   * @type {number}
   * @memberof PaginatedConversationalAgentInferencerPolymorphicList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedConversationalAgentInferencerPolymorphicList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedConversationalAgentInferencerPolymorphicList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ConversationalAgentInferencerPolymorphic>}
   * @memberof PaginatedConversationalAgentInferencerPolymorphicList
   */
  results: Array<ConversationalAgentInferencerPolymorphic>;
}

/**
 * Check if a given object implements the PaginatedConversationalAgentInferencerPolymorphicList interface.
 */
export function instanceOfPaginatedConversationalAgentInferencerPolymorphicList(
  value: object,
): value is PaginatedConversationalAgentInferencerPolymorphicList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedConversationalAgentInferencerPolymorphicListFromJSON(
  json: any,
): PaginatedConversationalAgentInferencerPolymorphicList {
  return PaginatedConversationalAgentInferencerPolymorphicListFromJSONTyped(json, false);
}

export function PaginatedConversationalAgentInferencerPolymorphicListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedConversationalAgentInferencerPolymorphicList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ConversationalAgentInferencerPolymorphicFromJSON),
  };
}

export function PaginatedConversationalAgentInferencerPolymorphicListToJSON(
  value?: PaginatedConversationalAgentInferencerPolymorphicList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ConversationalAgentInferencerPolymorphicToJSON),
  };
}
